import { FormFooter, FormFooterCancel, FormFooterSubmit } from 'components';
import { useFormPrompt } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';
import { ROUTES, useNavigate } from 'libs/navigation';

interface SubmitableFormFooterProps {
  submitLoading: boolean;
}

export const CreatableFormFooter = ({
  submitLoading,
}: SubmitableFormFooterProps) => {
  const { dirty } = useFormContext();
  const { canGoBack, goBack, navigate, params } = useNavigate();

  useFormPrompt();

  const navigateBack = () => {
    if (canGoBack) {
      goBack();
    } else {
      navigate(ROUTES.directories.directory.fullPath, {
        schemaId: params.schemaId!,
      });
    }
  };

  return (
    <FormFooter>
      <FormFooterCancel onClick={navigateBack} />
      <FormFooterSubmit disabled={!dirty} loading={submitLoading} />
    </FormFooter>
  );
};
